module.exports = __webpack_public_path__ + "img/infra1.9e717a37.png";